/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_TitleInputs */

const tr_onbilgi_title = /** @type {(inputs: Onbilgi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ön Bilgilendirme Formu`)
};

const en_onbilgi_title = /** @type {(inputs: Onbilgi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-Information Form`)
};

const de_onbilgi_title = /** @type {(inputs: Onbilgi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorab-Informationsformular`)
};

const ru_onbilgi_title = /** @type {(inputs: Onbilgi_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма предварительного информирования`)
};

/**
* | output |
* | --- |
* | "Pre-Information Form" |
*
* @param {Onbilgi_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_title = /** @type {((inputs?: Onbilgi_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_title(inputs)
	if (locale === "de") return de_onbilgi_title(inputs)
	if (locale === "ru") return ru_onbilgi_title(inputs)
	return tr_onbilgi_title(inputs)
});